var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "x_black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-02",
    transform: "translate(-1214.000000, -301.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(300.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(38.000000, 131.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(876.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.34166667,7.10441667 C8.31423784,7.07705709 8.29882265,7.03990795 8.29882265,7.00116667 C8.29882265,6.96242538 8.31423784,6.92527624 8.34166667,6.89791667 L13.7450833,1.49508333 C14.0867405,1.15294293 14.0863487,0.598615495 13.7442083,0.256958346 C13.4020679,-0.0846988019 12.8477405,-0.0843070569 12.5060833,0.257833333 L7.10325,5.65833333 C7.07589042,5.68576216 7.03874128,5.70117735 7,5.70117735 C6.96125872,5.70117735 6.92410958,5.68576216 6.89675,5.65833333 L1.49391667,0.257833333 C1.15225951,-0.0839849031 0.598193236,-0.0841154867 0.256375,0.257541667 C-0.0854432364,0.59919882 -0.08557382,1.1532651 0.256083333,1.49508333 L5.65833333,6.89791667 C5.68576216,6.92527624 5.70117735,6.96242538 5.70117735,7.00116667 C5.70117735,7.03990795 5.68576216,7.07705709 5.65833333,7.10441667 L0.256083333,12.5078333 C0.0350699078,12.728951 -0.0511900691,13.0511813 0.0297967013,13.3531434 C0.110783472,13.6551054 0.346713172,13.890924 0.648713368,13.9717684 C0.950713564,14.0526128 1.27290324,13.966201 1.49391667,13.7450833 L6.89675,8.34166667 C6.92410958,8.31423784 6.96125872,8.29882265 7,8.29882265 C7.03874128,8.29882265 7.07589042,8.31423784 7.10325,8.34166667 L12.5060833,13.7450833 C12.8477405,14.0869016 13.4018068,14.0870321 13.743625,13.745375 C14.0854432,13.4037178 14.0855738,12.8496516 13.7439167,12.5078333 L8.34166667,7.10441667 Z",
    id: "x_black"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXBlack);
export default __webpack_public_path__ + "static/media/x_black.4f9eeccf0d2ac6c7e3e3f292ec4aa8d7.svg";
export { ForwardRef as ReactComponent };